<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1 10C1 5.02944 5.02944 1 10 1V1C14.9706 1 19 5.02944 19 10V10C19 14.9706 14.9706 19 10 19V19C5.02944 19 1 14.9706 1 10V10Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="40"
      stroke-linecap="square"
    />
    <path
      d="M13 10L7.75 13.4641L7.75 6.5359L13 10Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="40"
      stroke-linecap="square"
    />
  </svg>
</template>
